
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Saint-Denis dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Saint-Denis certifiée Google Partner, accompagne les entreprises dionysiennes pour accroître leur visibilité et générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Saint-Denis dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Saint-Denis certifiée Google Partner, accompagne les entreprises dionysiennes pour accroître leur visibilité et générer plus de prospects.",
        },
      ],
    };
  },
};
